module.exports = __webpack_public_path__ + "img/123ne.06dc3ccb.svg";